export default __webpack_public_path__ + "static/media/winscreen.eb0869ad.png";